import { EnergyType } from '@energy-retailer/constants';
import { Electricity, Gas } from '@energy-retailer/icons';

import { useRatesPricingContext } from '@/app/providers/rates-pricing';

import PlanListGroup from './plan-list-group';

import type { PlanListProps } from './plan-list.types';

const PlanList = ({ showAll, isPostcodeSearch }: PlanListProps) => {
  const {
    state: {
      items,
      filters: { customerType },
    },
  } = useRatesPricingContext();

  if (items.length === 0) {
    return null;
  }

  const gasPricing = items.filter(
    ({ distributor }) => distributor.energyType === EnergyType.Gas
  );

  const electricityPricing = items.filter(
    ({ distributor }) => distributor.energyType === EnergyType.Electricity
  );

  const planListTitle = (energyType: EnergyType): string => {

    if (showAll) {
      switch (energyType) {
        case EnergyType.Electricity:
          return `Electricity offers`;
        case EnergyType.Gas:
          return `Gas offers`;
        default:
          return '';
      }
    }
    if (!isPostcodeSearch) return 'This plan matches your ID';

    return `${energyType} offers for your ${customerType.name.toLowerCase()}`;

  };

  return (
    <div className="container">
      <div className="flex flex-col gap-y-e md:gap-y-d">
        {electricityPricing.length > 0 ? (
          <PlanListGroup
            icon={<Electricity />}
            title={planListTitle(EnergyType.Electricity)}
            items={electricityPricing}
            {...(isPostcodeSearch && { icon: <Electricity /> })}
          />
        ) : null}

        {gasPricing.length > 0 ? (
          <PlanListGroup
            icon={<Gas />}
            title={planListTitle(EnergyType.Gas)}
            showTariff={false}
            items={gasPricing}
            {...(isPostcodeSearch && { icon: <Gas /> })}
          />
        ) : null}
      </div>
    </div>
  );
};

export default PlanList;
